"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("taelTableStateManager", function ($http) {
  var tableStateMap = {};
  function loadTableStates() {
    return $http.get("/rest/infinitable/table-states").then(function (response) {
      tableStateMap = _.chain(response.data).map(function (tableConfig) {
        return [tableConfig.tableId, tableConfig];
      }).fromPairs().value();
    });
  }
  function saveTableState(tableId) {
    // TODO : deferred ?
    return $http.post("/rest/infinitable/table-state/save", tableStateMap[tableId]).then(function (response) {
      return response.response;
    });
  }
  return {
    $load: function $load() {
      return loadTableStates();
    },
    handleConfig: function handleConfig(tableConfig) {
      return !tableConfig.generatedId;
    },
    getTableState: function getTableState(tableId) {
      return tableStateMap[tableId] || {};
    },
    setTableState: function setTableState(tableId, tableState) {
      tableState.tableId = tableId;
      tableStateMap[tableId] = tableState;
      saveTableState(tableId);
    }
  };
});
ngModule.run(function (taelTableStateManager, infiniTableConfigManager) {
  infiniTableConfigManager.setTableStateManager(taelTableStateManager);
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/taelTableStateManager.js
// module id = 2818
// module chunks = 13